



















































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Mixins
import SupportTicketInjectorMixin from "@/mixins/supportTicketInjectorMixin";
import CProdMixin from "@/mixins/cProdMixin";
import { DataModules } from "@/store/modules/data";
import { IRoute } from "@/models/routes";
import { CreateElement } from "vue";

@Component({
  computed: {
    ...mapGetters({
      canShowNotesAndSecrets: "data/clients/vaultAssets/canShowNotesAndSecrets"
    })
  },
  components: {
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue")
  }
})
export default class TicketRelatedProductComponent extends Mixins(
  SupportTicketInjectorMixin,
  CProdMixin
) {
  // Getters

  public canShowNotesAndSecrets!: boolean;
  // Props
  @Prop({
    required: true,
    validator: tag => ["u-aside", "u-section-box"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    return !!this.ticketData.hasRelatedProduct;
  }

  public get hasImage() {
    return !!this.ticketData.contractProduct?.product?.image;
  }

  public get isImported() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/isImported`
    ](this.ticketData.contractProduct);
  }

  public get isDelegatedAccess() {
    return !!this.ticketData?.contractProduct?.is_delegated_object;
  }

  public get canViewOrder() {
    if (this.isImported) return false;
    if (this.isDelegatedAccess) return false;
    return !!this.cProdOrderRoute;
  }

  public get cProdCondition() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/conditionSummary`
    ](this.ticketData?.contractProduct, this.$route);
  }

  public get cProdSummary() {
    if (!this.cProdCondition) return undefined;
    const { type, summary, icon } = this.cProdCondition;
    return {
      render: (h: CreateElement) =>
        h("span", [
          h("b-icon", {
            props: { icon, type, size: "is-small" },
            class: "has-margin-right-25"
          }),
          h(summary)
        ])
    };
  }

  public get cProdRoute() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/route`](
      this.ticketData.contractProduct
    )?.to as IRoute["to"];
  }

  public get cProdOrderRoute() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/routeToOrder`
    ](this.ticketData.contractProduct)?.to as IRoute["to"];
  }

  public get cProdPurchaseDate() {
    return this.$moment
      .utc(this.ticketData?.contractProduct?.created_at)
      .format(this.$t("_datetime.date.long").toString());
  }

  public get uniqueKey() {
    return this.ticketData.contractProduct?.id;
  }

  // Methods

  public openNotesModal() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/openNotesModal`,
      {
        props: {
          contractId: this.ticketData.contractProduct.contract_id,
          productId: this.ticketData.contractProduct.id
        }
      }
    );
  }

  public openSecretsModal() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/openSecretsModal`,
      {
        props: {
          contractId: this.ticketData.contractProduct.contract_id,
          productId: this.ticketData.contractProduct.id
        }
      }
    );
  }
}
